<!-- breadcrumbs original -->
<!--<ol class="breadcrumb icon-home icon-angle-right p-0">-->
<!--<li *ngFor="let router of routerList;">-->
<!--<a routerLink="/{{router.link}}" translate>{{router.name}}</a>-->
<!--</li>-->
<!--</ol>-->
<!--/breadcrumbs original -->
<div class="max-app-width mx-auto">
  @if (show) {
    <ol itemscope
      itemtype="http://schema.org/BreadcrumbList"
      class="breadcrumb icon-angle-right p-0 d-flex justify-content-start align-items-center" id="breadcrumbs-generic">
      @for (router of routerList; track router; let last = $last; let i = $index) {
        <li itemscope
          itemtype="http://schema.org/ListItem"
          itemprop="itemListElement"
          >
          @if (!last && router.name !== '') {
            <a itemprop="name" translate routerLink="/{{router.link}}" [innerHTML]="router.name" class="cursor-pointer" [queryParams]="queryParams"></a>
          }
          @if (!last && router.name === '') {
            <a translate routerLink="/{{router.link}}" class="cursor-pointer" [queryParams]="queryParams">
              <i class="fa fa-house-damage"></i>
            </a>
          }
          @if (last && router.name) {
            <span itemprop="name" translate [innerHTML]="router.name"></span>
          }
          @if (!last) {
            <span class="dividend">/</span>
          }
          <meta itemprop="position" [content]="i+1"/>
          <meta itemprop="item" content="{{ this.currentURL + router.link }}"/>
        </li>
      }
    </ol>
  }
</div>
